var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsWorkflows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "workflows__Type=Workflows, State=Enabled",
    className: "workflows__Type=Workflows, workflows__State=Enabled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "workflows__Vector",
    className: "workflows__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.458 5.292a1.93 1.93 0 1 0-1.93 1.93v1.372l-.17-.005a3.302 3.302 0 0 1-3.127-3.127l-.004-.17a3.302 3.302 0 0 1 3.301-3.301l.17.004a3.302 3.302 0 0 1 3.131 3.297l-.004.17a3.302 3.302 0 0 1-3.297 3.132V7.222a1.93 1.93 0 0 0 1.93-1.93Zm8.942 7.244a1.93 1.93 0 1 0-1.93 1.93v1.371l-.17-.004a3.302 3.302 0 0 1-3.127-3.128l-.004-.17a3.302 3.302 0 0 1 3.301-3.3l.17.004a3.302 3.302 0 0 1 3.132 3.297l-.005.17a3.302 3.302 0 0 1-3.297 3.131v-1.371a1.93 1.93 0 0 0 1.93-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.402 7.56c.125 1.18.608 2.414 1.484 3.305.857.87 2.132 1.46 3.964 1.309l.112 1.366c-2.22.182-3.9-.54-5.054-1.714a6.034 6.034 0 0 1-.502-.585v4.822H7.034v-8.43l1.368-.072Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.458 18.69a1.93 1.93 0 1 0-1.93 1.93v1.37l-.17-.004a3.302 3.302 0 0 1-3.127-3.127l-.004-.17a3.302 3.302 0 0 1 3.301-3.301l.17.004a3.302 3.302 0 0 1 3.131 3.297l-.004.17a3.302 3.302 0 0 1-3.297 3.132v-1.372a1.93 1.93 0 0 0 1.93-1.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsWorkflows);
export default __webpack_public_path__ + "static/media/sidebar-icons-workflows.d741a99c15fa084ed5e2c9aa38caa57c.svg";
export { ForwardRef as ReactComponent };